import { WidgetType } from "@src/types/dashboards";

/**
 * Static widget library registry — only entries that map to a built FE/BE
 * widget are listed here. Static content widgets (text/header/separator) are
 * handled separately (F7), so they are not listed here.
 * ponytail: names/descriptions are English literals for now — i18n them with F9
 * once the widget-type strings land.
 */
export type WidgetLibraryCategory =
  | "all"
  | "status"
  | "values"
  | "trends"
  | "counters";

export interface WidgetLibraryDef {
  type: WidgetType;
  name: string;
  description: string;
  category: WidgetLibraryCategory;
  defaultW: number;
  defaultH: number;
}

export const WIDGET_LIBRARY_CATEGORIES: WidgetLibraryCategory[] = [
  "all",
  "status",
  "values",
  "trends",
  "counters",
];

export const WIDGET_LIBRARY_DEFS: WidgetLibraryDef[] = [
  {
    type: "machine-overview",
    name: "Machine Overview",
    description: "Status badge, cycle counter and progress",
    category: "status",
    defaultW: 6,
    defaultH: 5,
  },
  {
    type: "counter-number",
    name: "Actual vs. Target Gauge",
    description: "Radial gauge bound to a numeric value and target",
    category: "counters",
    defaultW: 4,
    defaultH: 5,
  },
  {
    type: "single-text-value",
    name: "Single Text Value",
    description: "Label above a big number — current value of a node",
    category: "values",
    defaultW: 4,
    defaultH: 4,
  },
  {
    type: "multiple-text-values",
    name: "Multiple Values Text",
    description: "A compact table of up to 10 values, each from its own node",
    category: "values",
    defaultW: 4,
    // One entry + the tile's own chrome — see multipleTextValuesHeight.
    defaultH: 2,
  },
  {
    type: "trend-line",
    name: "Trend Line Chart",
    description: "Time series with target line",
    category: "trends",
    // Same min/max constraints as the gauge (user decision).
    defaultW: 5,
    defaultH: 5,
  },
  {
    type: "multi-line",
    name: "Multi-line Chart",
    description: "Multiple series over time",
    category: "trends",
    // Realigned from 12×7 stub to the gauge-like set (multi-line is a
    // taller chart with up to 5 series — needs vertical room per spec §2).
    defaultW: 5,
    defaultH: 5,
  },
  {
    type: "shot-data-line-chart",
    name: "Shot Data Line Chart",
    description: "Shot-data fields over time",
    category: "trends",
    defaultW: 5,
    defaultH: 5,
  },
];
